var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md:pl-10 w-full md:w-3/4 md:pr-10" },
    [
      _vm.event.published
        ? [
            _c("h1", { staticClass: "mb-6" }, [_vm._v("Event Status")]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-6" }, [
              _vm._v("Your event has been published!"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-6" }, [
              _vm._v(
                "\n            Attendee count: " +
                  _vm._s(_vm.count) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-6" }, [
              _c("strong", [_vm._v("Attendees")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button mb-12 ml-5",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.exportEvent.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("CSV Export")]
              ),
            ]),
          ]
        : [
            _vm.isReviewable
              ? [
                  _c("h1", { staticClass: "mb-6" }, [
                    _vm._v("Submit for Review"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-6" }, [
                    _vm._v(
                      "\n              When you have completed entering your event and ticketing information, please submit for review by the Reimagine team. Reimagine will review your event to ensure it's aligned with our mission and values prior to publishing. Reimagine reserves the right to not publish an event. Once the event is published and live on the Reimagine website, you will receive an email notification.                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-6" }, [
                    _c("div", { ref: "agree", staticClass: "my-3" }, [
                      _c("p", [
                        _vm._v(
                          "By submitting the event and ticketing information, I acknowledge and agree: (A) the submitted information is governed by and is incorporated into and a part of the collaborator agreement; and (B) if I am submitting on behalf of an organization, I warrant that I am authorized by the organization to do so on its behalf"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-12" }, [
                      _c("div", { staticClass: "select-box" }, [
                        _c("label", { staticClass: "text-base font-normal" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.agreeToTerms,
                                expression: "agreeToTerms",
                              },
                            ],
                            attrs: { type: "checkbox", name: "agree" },
                            domProps: {
                              checked: Array.isArray(_vm.agreeToTerms)
                                ? _vm._i(_vm.agreeToTerms, null) > -1
                                : _vm.agreeToTerms,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.agreeToTerms,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.agreeToTerms = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.agreeToTerms = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.agreeToTerms = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "check inline-block mr-2",
                          }),
                          _vm._v(
                            " I agree to terms for event submission\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("agree"),
                                expression: "errors.has('agree')",
                              },
                            ],
                            staticClass: "error text-error-red text-lg",
                          },
                          [_vm._v(_vm._s(_vm.errors.first("agree")))]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button mb-5",
                        class: {
                          "opacity-50 cursor-not-allowed": _vm.disableButton,
                        },
                        attrs: { disabled: _vm.disableButton },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.isSubmittable.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm.saving
                          ? [_vm._v("Processing...")]
                          : [_vm._v("Submit for Review")],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "PLEASE NOTE: You cannot submit for review until you have completed your Collaborator Agreement. If you receive an error message upon clicking the submit button above, you have not sufficiently provided some information. Please review your event and complete all required fields."
                      ),
                    ]),
                  ]),
                ]
              : [
                  _c("h1", { staticClass: "mb-6" }, [_vm._v("Event Status")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-6" }, [
                    _vm._v(
                      "\n                Your event has been submitted for review! Please allow 1-2 business days for approval.\n            "
                    ),
                  ]),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }